export var NewCategoryCreateTrigger;
(function (NewCategoryCreateTrigger) {
    NewCategoryCreateTrigger[NewCategoryCreateTrigger["OnEnterOnTextField"] = 0] = "OnEnterOnTextField";
    NewCategoryCreateTrigger[NewCategoryCreateTrigger["OnBlurOnTextField"] = 1] = "OnBlurOnTextField";
    NewCategoryCreateTrigger[NewCategoryCreateTrigger["OnBlurOnColorPicker"] = 2] = "OnBlurOnColorPicker";
    NewCategoryCreateTrigger[NewCategoryCreateTrigger["OnSelectColor"] = 3] = "OnSelectColor";
})(NewCategoryCreateTrigger || (NewCategoryCreateTrigger = {}));
export default {
    categoryOptionsyNewCategoryCreate: {
        datapoint: {
            name: 'Category_Options_newCategoryCreated',
            customData: function (createSource) { return [createSource]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map